import React from "react";
import Tickets from "../modules/Tickets/Tickets";

export default function TicketsPage() {
  return <Tickets />;
}
